module.exports = __webpack_public_path__ + "img/1.fb20ea33.svg";